var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.03 11.47L14.74 7.18C14.45 6.89 13.97 6.89 13.68 7.18C13.39 7.47 13.39 7.95 13.68 8.24L16.69 11.25H6.5C6.09 11.25 5.75 11.59 5.75 12C5.75 12.41 6.09 12.75 6.5 12.75H16.69L13.68 15.76C13.39 16.05 13.39 16.53 13.68 16.82C13.83 16.97 14.02 17.04 14.21 17.04C14.4 17.04 14.59 16.97 14.74 16.82L19.03 12.53C19.17 12.39 19.25 12.2 19.25 12C19.25 11.8 19.17 11.61 19.03 11.47Z",
    fill: "#065EEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.80f965a62c5f832fdeb7d175f573f655.svg";
export { ForwardRef as ReactComponent };